import { query, serviceQueries } from '@estee/elc-service-bus';
import { action, computed, observable } from 'mobx';

import { AuthenticatedRepository } from './AuthenticatedRepository';

interface IData {
    isLoyaltyMember: boolean;
}

export class AccountRepository extends AuthenticatedRepository {
    @observable private isLoyaltyMember: boolean;

    constructor() {
        super();
    }

    @action public fetchAccountInfo = async () => {
        return super.ensureData();
    };

    @action public fetchData = async () => {
        const isLoyaltyMember = !!(await query(serviceQueries.IS_LOYALTY_MEMBER));

        this.setData({ isLoyaltyMember });
    };

    @action public setData = ({ isLoyaltyMember }: IData) => {
        this.isLoyaltyMember = isLoyaltyMember;
    };

    @computed public get showLoyalty() {
        return this.isLoyaltyMember;
    }
}
